<template>
  <div id="app">
    <!-- 深邃暗黑霓虹紫环境底色与柔和微光装饰 -->
    <div class="brand-ambient-glow glow-top"></div>
    <div class="brand-ambient-glow glow-middle"></div>
    <div class="brand-ambient-glow glow-bottom"></div>
    <div class="brand-ambient-rings"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #F1F5F9;
  background-color: #07070D;
  background-image: 
    radial-gradient(ellipse 90% 45% at 50% -5%, rgba(139, 92, 246, 0.18) 0%, transparent 65%),
    radial-gradient(ellipse 70% 35% at 90% 30%, rgba(99, 102, 241, 0.12) 0%, transparent 60%),
    linear-gradient(180deg, #07070D 0%, #0D0C1A 50%, #05050A 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.9);
}

/* 暗黑环境蓝紫微光微晕 */
.brand-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(80px);
}

.glow-top {
  top: -90px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 220px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.25) 0%, rgba(99, 102, 241, 0.12) 50%, transparent 75%);
}

.glow-middle {
  top: 32%;
  right: -70px;
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, rgba(168, 85, 247, 0.14) 0%, transparent 70%);
}

.glow-bottom {
  bottom: -70px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 220px;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.15) 0%, transparent 75%);
}

/* 极细弧线装饰 (科技霓虹紫质感) */
.brand-ambient-rings {
  position: fixed;
  top: -60px;
  right: -60px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  border: 1.5px dashed rgba(168, 85, 247, 0.14);
  pointer-events: none;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 24px;
    left: 24px;
    right: 24px;
    bottom: 24px;
    border-radius: 50%;
    border: 1px solid rgba(139, 92, 246, 0.08);
  }
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
